import { Container, Nav, Navbar } from "react-bootstrap";


export default function AppNavbar(){
  return(
    <div>
      <Navbar bg="dark" data-bs-theme="dark">
        <Container>
          <Navbar.Brand href="#home">漢文クイズプレーヤー</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/">Player</Nav.Link>
            <Nav.Link href="userguide">User Guide</Nav.Link>
          </Nav>
        </Container>
      </Navbar>

    </div>
  )
}